import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { initMetaPixel, trackPageView, wasPixelBootstrappedFromHtml } from '../utils/metaPixel'

/**
 * Fires a Meta Pixel PageView on every client-side route change. Mounted
 * inside <Router> in App.jsx so it sees every navigation.
 *
 * The initial PageView is normally sent by the inline snippet in index.html
 * (long before this component mounts), so the first render is skipped in that
 * case to avoid a duplicate. When the snippet did not run, initMetaPixel()
 * bootstraps the pixel and the first PageView is sent from here as before.
 */
const MetaPixelPageView = () => {
  const { pathname } = useLocation()
  const isFirstRender = useRef(true)

  useEffect(() => {
    initMetaPixel()

    if (isFirstRender.current) {
      isFirstRender.current = false
      if (wasPixelBootstrappedFromHtml()) return
    }

    trackPageView()
  }, [pathname])

  return null
}

export default MetaPixelPageView
